<template>
  <div class="w640">
    <h3>编辑活动信息</h3>
    <el-form
      size="mini"
      label-width="180px"
      :model="formData"
      :rules="rules"
      ref="formData"
    >
      <el-form-item label="角色">
        <el-select v-model="formData.role">
          <el-option
            v-for="(label, value) in map.roles"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input
          type="text"
          v-model="formData.title"
          placeholder="活动标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="content">
        <el-input
          type="textarea"
          rows="5"
          v-model="formData.content"
          placeholder="活动描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="imgUrl">
        <!-- action="https://upload.qbox.me/" -->
        <el-upload
          action="https://up-z1.qbox.me/"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :data="uploadData"
        >
          <img v-if="formData.imgUrl" :src="formData.imgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <el-input type="hidden" v-model="formData.imgUrl"></el-input>
        </el-upload>
        <p>建议尺寸：1175*500像素；建议大小：10M以内;</p>
      </el-form-item>
      <el-form-item label="链接" prop="url">
        <el-input
          type="text"
          v-model="formData.url"
          placeholder="活动链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="priority">
        <el-input
          type="text"
          v-model.number="formData.priority"
          placeholder="活动排序"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button @click="submit">保存</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
const { activity } = api;

export default {
  name: "activityEdit",
  data() {
    return {
      map,
      formData: {
        role: 3,
        title: "",
        content: "",
        url: "",
        imgUrl: "",
        priority: 0,
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      isUploading: false,
      isSubmiting: false,
      rules: {
        title: [
          {
            required: true,
            message: "请填写活动标题",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写活动描述",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "请填写活动链接",
            trigger: "change",
          },
          {
            type: "url",
            message: "活动链接格式错误",
            trigger: "change",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请上传活动图片",
            trigger: "change",
          },
        ],
        priority: [
          {
            required: true,
            message: "请填写活动排序",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    id() {
      return this.$route.query.id;
    },
    action() {
      return this.id ? "update" : "create";
    },
  },
  watch: {},
  methods: {
    async getDetail() {
      let obj = {
        id: this.id,
      };
      let {
        data: { code, data },
      } = await activity.detail(obj);
      if (code == 200) {
        this.formData = data;
      }
    },
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    handleSuccess(res, file) {
      this.formData.imgUrl = `https:\/\/image.duiyou360.com/${res.key}`;
      this.isUploading = false;
    },
    beforeUpload(file) {
      this.isUploading = true;
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
    },
    submit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          if (this.isSubmiting || this.isUploading) return false;
          this.isSubmiting = true;
          let obj = this.formData;
          if (this.id) obj.id = this.id;
          let {
            data: { code, data },
          } = await api.activity[this.action](obj);
          let vue = this;
          if (code == 200) {
            this.$message({
              showClose: false,
              message: "保存成功",
              type: "success",
              onClose() {
                if (vue.id) {
                  window.location.reload();
                } else {
                  window.location.href = `/activities`;
                }
              },
            });
          }
          this.isSubmiting = false;
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.id) {
      this.getDetail();
    }
  },
  mounted() {
    this.getToken();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/activity/edit.vue